"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generator;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _makeThemeVars = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/makeThemeVars"));

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/* Global variables (colors, typography, spacing, etc.) are defined in lib/themes */
function generator(_ref) {
  var typography = _ref.typography,
      colors = _ref.colors,
      borders = _ref.borders,
      spacing = _ref.spacing,
      shadows = _ref.shadows,
      stacking = _ref.stacking,
      breakpoints = _ref.breakpoints;
  return (0, _objectSpread2.default)({
    fontFamily: typography.fontFamily,
    color: colors.oxford,
    background: colors.white,
    borderColor: colors.tiara,
    colorInverse: colors.white,
    backgroundInverse: colors.oxford,
    borderColorInverse: 'transparent',
    debugOutlineColor: colors.borderDebug,
    backgroundLight: colors.porcelain,
    borderStyle: borders.style,
    arrowSize: '0.5rem',
    xSmallMaxWidth: breakpoints.xSmall,
    smallMaxWidth: breakpoints.small,
    mediumMaxWidth: breakpoints.medium,
    largeMaxWidth: breakpoints.large
  }, (0, _makeThemeVars.default)('margin', spacing), (0, _makeThemeVars.default)('padding', spacing), (0, _makeThemeVars.default)('shadow', shadows), (0, _makeThemeVars.default)('stacking', stacking), (0, _makeThemeVars.default)('border', borders));
}